module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/getFunctionName.js
 ** module id = 488
 ** module chunks = 1
 **/